var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "relationListWidget" + _vm.$root.id } },
    [
      _c("relationList", {
        attrs: {
          contentid: _vm.$root.id,
          newsid: _vm.$root.newsid,
          productid: _vm.$root.productid,
          settings: _vm.$root.settings,
          admin: _vm.$root.admin,
          attr: _vm.$root.attr
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }